import { Component, OnInit, Input } from '@angular/core';
import * as aspSettings from '../../asp/aspSettings';
import { mainMapMngr } from '../../asp/MapMngr';
import { AppInjector } from '@core_n/common/inject';
import { AroSensorService } from 'src/app/aro/aro-sensor.service';
import { SensorObject } from 'src/app/asp/SensorObject';
import { MsgBoxService } from '@core_n/msg-boxes/msg-box.service';
import * as msgs from '../../../../app/msg/projMsgs';
import { UserActionService } from '@core_n/user-action/user-action.service';
import { TranslateService } from '@ngx-translate/core';
import { SoundMsgMngrService } from '@core_n/msg/sound-msg-mngr.service';

@Component({
  selector: 'acoustic-snippet',
  templateUrl: './acoustic-snippet.component.html',
  styleUrls: ['./../sensor-window.component.scss']
})
export class AcousticSnippetComponent implements OnInit {
  @Input() sensor: any;
 
  public sliderState: boolean;
  constructor(
    protected msgBox: MsgBoxService, 
    protected trans: TranslateService,
    protected soundService: SoundMsgMngrService) {

  }

  ngOnInit() {
    this.sliderState = this.sensor.logiConn;

    console.log(`Acoustic Sensor from acoustic-snippet : ${this.sensor}`);

    this.sensor.ObjectUpdate.subscribe(x => {
      this.sliderState = this.sensor.logiConn;
    });
  }

  ngAfterViewInit() {
  }

  hookSensor() {
    aspSettings.clearSelectedIds();
    aspSettings.selectedIds.add(this.sensor.sensorID);
    this.sensor.setHooked(true);
  }

  OpenSoundWindow() {
    // call service to open the window and handle only one instance at a time... // TBD
    this.soundService.openSoundPlayerWindow(this.sensor.sensorID, this.sensor.name);
  }

  setCenter() {
    mainMapMngr.setMapCenter(this.sensor.geometry);
  }

  openAro() {
    AppInjector.get(AroSensorService).showWindow(this.sensor as SensorObject);
  }

  editAro() {
    AppInjector.get(AroSensorService).showWindow(this.sensor as SensorObject, true);
  }

  async deleteSensor() {
    let confirmed = await this.msgBox.showConfirmMsgBox(this.trans.instant('ACTIONS.DELETE_SENSOR_MSG'), this.trans.instant('ACTIONS.DELETE_SENSOR_TITLE'), "Yes", "No");
    if (!confirmed)
      return;
    let sensormsg = new msgs.SetSensor();
    sensormsg.Sic = this.sensor.sic;
    sensormsg.Sac = this.sensor.sac;
    // sensormsg.isDelete = true;
    AppInjector.get(UserActionService).sendUserAction(sensormsg);
  } 

  sliderClick() {
    let sensormsg = new msgs.SetSensor();
    sensormsg.Sic = this.sensor.sic;
    sensormsg.Sac = this.sensor.sac;
    // sensormsg.LogicallyConnected = this.sliderState;

    AppInjector.get(UserActionService).sendUserAction(sensormsg);
  }
}
